import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Optional,
	Output,
} from "@angular/core";
import { FormControl, FormGroupDirective } from "@angular/forms";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { DATE_FORMATS, FormFieldType } from "../form-field.model";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";
import momentPort from "moment";
import { FormFieldDirective } from "../form-field";
import { dateMask } from "app/shared";
import { createAutoCorrectedDatePipe } from "text-mask-addons";

@Component({
    selector: "tc-moment-field",
    templateUrl: "./moment-field.component.html",
    styleUrls: ["./moment-field.component.scss"],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: "en-AU" },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    ],
    standalone: false
})
export class MomentFieldComponent extends FormFieldDirective implements OnInit {
	private dateMask = dateMask;
	public mask: any;
	public datePicker = new FormControl();
	public startDate: any;
	public startDateBackup: any;
	public isValid: boolean;
	@Output() valueChanged = new EventEmitter<any>();
	@Input() dateFilterFn: (d: momentPort.Moment) => boolean;
	@Input() disableDatePicker = false;
	@Input() set backButtonTriggered(val) {
		this.registerCustomIcons();
	}
	@Input() set startDateValue(val: string) {
		const mmt = momentPort(val, "DD/MM/YYYY");
		if (mmt.isValid()) {
			this.startDate = mmt;
			this.startDateBackup = mmt;
		}
	}

	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		formGroupDirective: FormGroupDirective,
		private iconRegistry: MatIconRegistry,
		private sanitizer: DomSanitizer
	) {
		super(formGroupDirective);
		this.registerCustomIcons();
		this.mask = {
			mask: this.dateMask,
			guide: true,
			placeholderChar: "\u2000",
			pipe: createAutoCorrectedDatePipe("dd/mm/yyyy"),
		};
		this.placeholder = "01/01/1900";
	}

	ngOnInit(): void {
		this.type = FormFieldType.MOMENT;
		this.datePicker.valueChanges
			.pipe(
				distinctUntilChanged(
					(p, c) => JSON.stringify(p) === JSON.stringify(c)
				),
				takeUntil(this.unsubscribeAll)
			)
			.subscribe((val: momentPort.Moment) => {
				this.control.markAsTouched();
				this.control.markAsDirty();
				const dt = val.format("DD/MM/YYYY");
				const mmt = momentPort(dt, "DD/MM/YYYY");
				this.control.setValue(dt, { emitEvent: false });
				this.control.updateValueAndValidity();
				this.startDate = mmt;
				this.valueChanged.emit(dt);

				if (this.dateFilterFn) {
					this.isValid = this.dateFilterFn(mmt);
					if (!this.isValid) {
						this.control.setErrors(this.errorFn);
					}
				}
			});

		this.control?.valueChanges
			.pipe(
				distinctUntilChanged(
					(p, c) => JSON.stringify(p) === JSON.stringify(c)
				),
				takeUntil(this.unsubscribeAll)
			)
			.subscribe((val: string) => {
				const dt = this.cleanMaskValue(val);
				if (dt && dt.length === 10) {
					const mmt = momentPort(dt, "DD/MM/YYYY");
					this.valueChanged.emit(dt);
					if (mmt.isValid()) {
						this.datePicker.setValue(mmt, { emitEvent: false });
						this.startDate = mmt;
					}
					// if (this.dateFilterFn) {
					// 	this.isValid = this.dateFilterFn(mmt);
					// 	if (!this.isValid) {
					// 		this.control.setErrors(this.errorFn);
					// 	}
					// }
				} else if (dt?.length === 0) {
					this.startDate = this.startDateBackup;
				}
			});
	}

	get iconUrl(): string {
		if (this.disabled) {
			return "calendar-disable";
		}
		return this.hasError ? "calendar-red" : "calendar";
	}

	private registerCustomIcons(): void {
		this.iconRegistry.addSvgIcon(
			"calendar",
			this.sanitizer.bypassSecurityTrustResourceUrl(
				"assets/img/calendar.svg"
			)
		);
		this.iconRegistry.addSvgIcon(
			"calendar-red",
			this.sanitizer.bypassSecurityTrustResourceUrl(
				"assets/img/calendar-red.svg"
			)
		);
		this.iconRegistry.addSvgIcon(
			"calendar-disable",
			this.sanitizer.bypassSecurityTrustResourceUrl(
				"assets/img/calendar-disable.svg"
			)
		);
	}
}
